import { Component, OnInit, AfterViewInit, OnDestroy } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import {
    CclBuilderService,
    CclMessageService,
    CclCustomSiteModel,
    CclNavbarFooterService
} from "certain-common-library";
import { SharedService } from "../../../../../modules/shared/services/shared.service";
import { Subscription } from "rxjs";
import { FlashMessagesService } from "angular2-flash-messages";
import { CatalogService } from "../../../../../modules/shared/services/catalog.service";
import { UploadService } from "../../../../../modules/shared/services/upload.service";
import { UnsavedChangesDeactivate } from "../../../can-deactivate";
import { cloneDeep } from "lodash";
import { LocalDataService } from "../../../../../modules/shared/services/local-data.service";

@Component({
    selector: "app-header-page",
    templateUrl: "./header-page.view.html",
    styleUrls: []
})
export class HeaderPageView extends UnsavedChangesDeactivate implements AfterViewInit, OnInit, OnDestroy {
    subscription: Subscription;
    headerConfigObj: any;
    headerConfig: any;
    baseUrl: string;
    ddfJson = "session-ddf.json";
    ddfData: Array<any> = [];

    constructor(
        public sharedService: SharedService,
        public builderService: CclBuilderService,
        private navbarFooterService: CclNavbarFooterService,
        private messageService: CclMessageService,
        private _flashMessagesService: FlashMessagesService,
        private catalogService: CatalogService,
        private activatedRoute: ActivatedRoute,
        private uploadService: UploadService,
        private localDataService: LocalDataService
    ) {
        super(sharedService);
        this.subscription = this.messageService.getMessage().subscribe((message) => this.saveHeaderConfig(message));
        if (this.activatedRoute.routeConfig.path === "header") {
            this.baseUrl = "header";
        } else if (this.activatedRoute.routeConfig.path === "footer") {
            this.baseUrl = "footer";
        }
    }

    ngOnInit() {
        this.sharedService.currentLayoutSection = this.baseUrl;
        this.headerConfigObj = this.sharedService.configs[this.sharedService.configTypes.HEADER_FOOTER[this.baseUrl]];
        this.builderService.setElementTypes(["image", "text", "spacer"]);
        this.builderService.currentPageKey = "landing";
        this.builderService.drawerSize = "mid";
        this.builderService.uploadImageFn = this.uploadfn.bind(this);
        if (this.headerConfigObj == null || this.headerConfigObj.id == null) {
            this.builderService.currentSite = <CclCustomSiteModel>(
                this.builderService.createBasicSiteNew(this.baseUrl).formPayload
            );
            this.headerConfigObj = {
                id: null,
                sessionCatalogSetup: {
                    id: this.sharedService.setup.id
                },
                config: null,
                configType: this.sharedService.configTypes.HEADER_FOOTER[this.baseUrl]
            };
        } else {
            this.headerConfig = JSON.parse(this.headerConfigObj.config);
            this.builderService.currentSite = this.headerConfig.template;
        }

        // For checking unsaved data
        this.sharedService.originalData = cloneDeep(this.headerConfig);
        this.sharedService.changedData = this.headerConfig;
        this.localDataService.getJSON(this.ddfJson).subscribe((data) => {
            if (data != null) {
                this.ddfData = data;
                this.builderService.textDdfGroups = ["Event", "Registration"];
                this.fetchDdfs();
    }
        });
    }

    fetchDdfs() {
        let ddfResults = [];
        for (let i = 0; i < this.ddfData.length; i++) {
            const ddf = this.ddfData[i];

            let groupName = ddf.type.toLowerCase();
            groupName = groupName.charAt(0).toUpperCase() + groupName.substring(1);
            const tinymceDdf = {
                group: groupName,
                title: ddf.label.trim(),
                variableKey: ddf.key.substring(2, ddf.key.length - 2),
                variableValue: ddf.label.trim()
            };
            ddfResults.push(tinymceDdf);
        }
        this.builderService.textDdfs = ddfResults;
        this.builderService.uglyDdfs = true;
    }

    ngAfterViewInit(): void {
        if (this.navbarFooterService.navbar != null && this.navbarFooterService.navbar.rightNavbarItems != null) {
            if (this.baseUrl == "header") {
                this.navbarFooterService.navbar.rightNavbarItems[0].label = "NEXT STEP: Define HTML";
            } else if (this.baseUrl == "footer") {
                this.navbarFooterService.navbar.rightNavbarItems[0].label = "NEXT STEP: Define Speaker Information";
            }
            this.navbarFooterService.navbar.rightNavbarItems[1].message = "save-header";
            this.navbarFooterService.navbar.rightNavbarItems[2].message = "save-next-header";
        }
        this.messageService.sendMessage("update-publish-button");
    }

    ngOnDestroy(): void {
        this.sharedService.unsubscribeHelper(this.subscription);
    }

    setHeader(ev) {
        this.headerConfig.template = ev;
    }

    saveHeaderConfig(message) {
        if (message.text == "save-header" || message.text == "save-next-header") {
            this.headerConfig.template = this.builderService.currentSite;
            this.headerConfigObj.config = JSON.stringify(this.headerConfig);
            this.catalogService.saveSetupConfig(this.headerConfigObj).subscribe((resp) => {
                // For checking unsaved data
                this.sharedService.originalData = cloneDeep(this.headerConfig);
                this.sharedService.changedData = this.headerConfig;

                this.headerConfigObj = resp.body["sessionCatalogSetupConfigDTO"];
                this.sharedService.configs[
                    this.sharedService.configTypes.HEADER_FOOTER[this.baseUrl]
                ] = this.headerConfigObj;
                this._flashMessagesService.show("Header saved successfully.", {
                    cssClass: "alert-success"
                });
                if (message.text == "save-next-header") {
                    if (this.baseUrl == "header") {
                        this.sharedService.currentLayoutSection = "html-top";
                        this.sharedService.catalogNavigateHelper("admin", "catalog/layout/html-top");
                    } else {
                        this.sharedService.currentLayoutSection = "speaker";
                        this.sharedService.catalogNavigateHelper("admin", "catalog/layout/speaker");
                    }
                }
            });
        }
    }

    uploadfn(file) {
        this.uploadService.fileUpload(file.formData).subscribe((resp) => {
            if (resp.body.hasOwnProperty("documentName")) {
                if (this.builderService.selectedElement.content.type == "image") {
                    this.builderService.selectedElement.content["image"] =
                        resp.body["documentPath"] + resp.body["documentName"];
                }
            }
        });
    }
}
